<template>
  <div @mouseover="checkShowDescription(true)" @mouseleave="checkShowDescription(false)">
    <EventDescription :project="project" :event="event" :show="showDescription"/>
    <EventContentVisible :events="events" :event="event" :index="index" v-if="showContentVisible"/>
  </div>
</template>

<script>
  import { eventBus } from './../../application'
  import EventDescription from './EventDescription.vue'
  import EventContentVisible from './EventContentVisible.vue'
  export default {
    props: {
      project: Object,
      events: Array,
      event: Object,
      index: null
    },
    methods: {
      checkShowDescription(hover) {
        // if (this.event.status_event == 'in_progress') {
        //   this.showDescription = hover && (this.event.childrens.length > 0)
        // }
        // if (this.event.status_event == 'finished') {
        //   this.showDescription = hover
        // }
        this.showDescription = hover
      }     
    },
    data() {
      return {
        showDescription: false,
        showContentVisible: true
      }
    },
    components: {
      EventDescription,
      EventContentVisible
    },
    mounted () {
      eventBus.$on('hideContentVisible', dataPassed => {
        this.showContentVisible = false
      })      
      eventBus.$on('showContentVisible', dataPassed => {
        this.showContentVisible = true
      });      
    }
  }
</script>

<style scoped>

</style>
